<template>
    <auction-dialog title="응찰하기" showsActions width="1034" @open="init" @close="destroy">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <auction-bids-data ref="bids-data" :bids="bids" />
        </template>
        <template #actions>
            <v-card outlined tile class="v-card--default-outlined">
                <v-card-text class="pa-20 pa-30">
                    <div class="mt-n6">
                        <v-row no-gutters v-for="price in priceInfo" :key="price.term" class="mt-6">
                            <v-col cols="5">
                                <span class="font-size-14 font-size-md-16 primary--text">{{ price.term }}</span>
                            </v-col>
                            <v-col cols="7" class="grey-68--text">
                                <span class="font-size-14 font-size-md-16 pl-md-10" :class="{ 'font-weight-bold primary--text': price.bold }">{{ price.desc?.format?.() }}</span>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider class="my-20" />
                    <v-row no-gutters align="center">
                        <v-col cols="5">
                            <span class="font-size-14 font-size-md-16 primary--text">응찰가</span>
                        </v-col>
                        <v-col cols="7">
                            <div class="pl-md-10">
                                <auction-actions-prices v-model="inputs.price" v-bind="attrs_prices" />
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="center" class="mt-6">
                        <v-col cols="5">
                            <auction-until>
                                <template #activator="{attrs,on}">
                                    <v-btn v-bind="attrs" v-on="on" text height="30" class="v-btn--none-active-bg px-0">자동응찰<i class="icon icon-help-circle-outline ml-6 ml-md-8"></i></v-btn>
                                </template>
                            </auction-until>
                        </v-col>
                        <v-col cols="7">
                            <div class="pl-md-10">
                                <auction-actions-prices v-model="inputs.price_until" v-bind="attrs_prices" :test="(value) => value > inputs.price" optional />
                            </div>
                        </v-col>
                    </v-row>
                    <v-divider class="my-20" />
                    <div>
                        <p class="font-size-14 grey-68--text">
                            * 최고 응찰가가 동일한 경우<br />
                            먼저 참여한 응찰자에게 낙찰됩니다.
                        </p>
                    </div>
                    <div class="mt-18 mt-md-24">
                        <v-btn block x-large color="primary" :disabled="isLastBidder" :loading="loading_btn" :dark="!isLastBidder" @click="makeBid">응찰하기</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </template>
    </auction-dialog>
</template>

<script>
import AuctionUntil from "./auction-until.vue";
import AuctionDialog from "./auction-dialog.vue";
import AuctionBidsData from "./auction-bids-data.vue";
import AuctionActionsPrices from "./auction-actions-prices.vue";
import api from "@/api";

export default {
    components: {
        AuctionUntil,
        AuctionDialog,
        AuctionBidsData,
        AuctionActionsPrices,
    },
    props: {
        work: { type: Object, default: () => ({}) },
        bids: { type: Array, default: () => [] },
    },
    data: () => ({
        inputs: {
            price: 0,
            price_until: null,
        },
        loading_btn: false,
    }),
    computed: {
        lastBid() {
            return this.bids.find(({ _id }) => _id == this.work?.price_auction?._bid);
        },

        isLastBidder() {
            const { _user } = this.$store.state.payload || {};
            return !!_user && _user == this.lastBid?._user;
        },

        priceInfo() {
            const { current = 0, from = 0, unit = 0 } = this.work?.price_auction || {};
            return [
                { term: "현재가", desc: current || from, bold: true },
                { term: "시작가", desc: from },
                { term: "호가단위", desc: unit },
            ];
        },

        attrs_prices() {
            const { current = 0, from = 0, unit = 0 } = this.work?.price_auction || {};
            const { isLastBidder: disabled = false } = this;
            return { from, current, unit, disabled };
        },

        params_makeBid() {
            const { _work } = this.$route.params;
            return {
                _work,
                ...this.inputs,
            };
        },
    },
    watch: {
        "work.price_auction.current"() {
            this.setPrice();
        },
    },
    methods: {
        setPrice() {
            const { current = 0, from = 0, unit = 0 } = this.work?.price_auction || {};
            this.inputs.price = current ? current + unit : from;
        },
        async init() {
            this.setPrice();
            this.$emit("refresh");
        },
        async destroy() {
            this.$nextTick(() => this.$refs["bids-data"]?.$destroy?.());
        },
        async makeBid() {
            this.loading_btn = true;
            try {
                const { bid } = await api.v1.auction.works.bids.post(this.params_makeBid);
                alert("성공적으로 응찰되었습니다.");
                this.init();
            } finally {
                this.loading_btn = false;
            }
        },
    },
};
</script>

<style></style>
